const activityModalComponent = (function() {
  var maskID = 'activity-modal--mask';

  var init = function() {
    $(document).on('click', '[data-function=open-activity-modal]', function(e) {
      e.preventDefault();
      var $modal = openModal($(this));
      App.Helpers.listenToCustomEvent($modal[0], 'activityModalComplete', function() { closeActivityModal($modal); });
    });

    $(document).on('click', '[data-function=close-activity-modal]', function(e) {
      e.preventDefault();
      closeActivityModal($(this).closest('.activity-modal--component'));
    });
  };

  var closeActivityModal = function(el) {
    $(el).removeClass('open');
    $('#' + maskID).remove();
    $(el).trigger('close');

    // Remove the modal itself after the animations run
    setTimeout(function() { $(el).remove(); }, 300);
  }

  //
  // INTERNAL USE
  //

  function openModal($button) {
    var modalID        = $button.data('modal');
    var modalContainer = $('<div id="' + maskID + '"></div>');
    App.Helpers.appendContent(document.body, modalContainer);
    var $content       = App.Helpers.appendContent(document.body, generateModal(modalID)).find('#' + modalID);
    setTimeout(function() { $content.addClass('open'); }, 1);
    $.get($button.data('url')).done(function(res) {
      $content.find('.modal--content').html(contentWithCloseLink(res));
    });
    return $content;
  }

  function generateModal(modalID) {
    var $template = $($('#activity-modal--template').html().replace(/MODAL-ID/g, modalID));
    $template.find('.modal--content').html(contentWithCloseLink(App.spinner()));
    return $template;
  }

  function contentWithCloseLink(content) {
    var contentHTML = '<a class="activity-modal--close-link" data-function="close-activity-modal"><i class="far fa-times"></i></a>';
    return contentHTML + content;
  }

  return {
    init:               init,
    closeActivityModal: closeActivityModal
  };
})();

export default class extends Controller {
  connect() {
    App.ActivityModalComponent = activityModalComponent;
    App.ActivityModalComponent.init();
  }
};



// WEBPACK FOOTER //
// ./app/components/modals/assets/javascript/activity-modal-controller.js